import { useNavigate } from "react-router-dom";

export default function useCustomNavigate() {
  const navigate = useNavigate();

  const navigateTo = (path, propData) => {
    navigate(path, propData);
  };
  return {
    navigateTo,
  };
}
